import {Component, HostListener, inject, Input, OnInit} from "@angular/core";
import { CommonModule } from "@angular/common";
import {faChevronLeft, faChevronRight, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {StudentExam} from "../../../dashboard/feature/studentDashboard/studentDashboard.component";
import {Router} from "@angular/router";
import * as querystring from "node:querystring";

interface CalendarDay {
  dayNumber: number;
  isCurrentMonth: boolean;
  toggleDropdown: boolean;
  exams?: StudentExam[];
}

@Component({
    selector: 'calendar',
    imports: [CommonModule, FontAwesomeModule, FormsModule],
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
  @Input('exams') exams: StudentExam[] = [];
  @Input('interactive') interactive: boolean = false
  date = new Date();
  router = inject(Router);
  calendarDays: CalendarDay[][] = [[],[],[],[],[],[]]

  ngOnInit(): void {
    this.fillCalendar()
  }

  ngOnChanges(): void {
    this.fillCalendar()
  }

  fillCalendar() {
    for(let exam of this.exams) {
      exam.finish_by = new Date(exam.finish_by);
    }
    this.calendarDays = [[],[],[],[],[],[]]
    const firstDayOfCurrentMonth = new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
    const currentMonthsMax = new Date(this.date.getFullYear(), this.date.getMonth()+1, 0).getDate();
    const lastMonthDate = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();

    let lastMonthStartDate = lastMonthDate - firstDayOfCurrentMonth + 1

    // Start the count at 2 since we set the first day of the month at 1
    let currentMonthDateCount = 2

    this.calendarDays[0][firstDayOfCurrentMonth] = {dayNumber: 1, isCurrentMonth: true, toggleDropdown: false, exams: this.exams.filter(exam => {
        return exam.finish_by.getMonth() === this.date.getMonth() && exam.finish_by.getDate() === 1 && this.date.getFullYear() === exam.finish_by.getFullYear();
      })};

    // Front fill first week of calendar with previous months days
    for (let i = 0; i < firstDayOfCurrentMonth; i++) {
      this.calendarDays[0][i] = {dayNumber: lastMonthStartDate, isCurrentMonth: false, toggleDropdown: false, exams: this.exams.filter(exam => {
          return exam.finish_by.getMonth() === this.date.getMonth() - 1 && exam.finish_by.getDate() === lastMonthStartDate && this.date.getFullYear() === exam.finish_by.getFullYear();
        })};
      lastMonthStartDate += 1
    }

    // Fill first week
    for(let i = firstDayOfCurrentMonth + 1; i < 7; i++) {
      this.calendarDays[0][i] = {dayNumber: currentMonthDateCount, isCurrentMonth: true, toggleDropdown: false, exams: this.exams.filter(exam => {
          return exam.finish_by.getMonth() === this.date.getMonth() && exam.finish_by.getDate() === currentMonthDateCount && this.date.getFullYear() === exam.finish_by.getFullYear();
      })}
      currentMonthDateCount += 1
    }

    let backfillCount = 1
    // Fill rest of the weeks until we hit the end of current month then start backfilling the rest of the calendar
    for(let week = 1; week < this.calendarDays.length; week++ ) {
      for(let i = 0; i < 7; i++) {
        if(currentMonthDateCount < currentMonthsMax + 1) {
          this.calendarDays[week][i] = {dayNumber: currentMonthDateCount, isCurrentMonth: true, toggleDropdown: false, exams: this.exams.filter(exam => {
              return exam.finish_by.getMonth() === this.date.getMonth() && exam.finish_by.getDate() === currentMonthDateCount && this.date.getFullYear() === exam.finish_by.getFullYear();
            })}
          currentMonthDateCount += 1
        } else {
          this.calendarDays[week][i] = {dayNumber: backfillCount, isCurrentMonth: false, toggleDropdown: false, exams: this.exams.filter(exam => {
              return exam.finish_by.getMonth() === this.date.getMonth() + 1 && exam.finish_by.getDate() === backfillCount && this.date.getFullYear() === exam.finish_by.getFullYear();
            })}
          backfillCount += 1
        }
      }
    }
  }

  incrementMonth() {
    this.date.setMonth(this.date.getMonth() + 1);
    this.fillCalendar()
  }

  decrementMonth() {
    this.date.setMonth(this.date.getMonth() - 1);
    this.fillCalendar()
  }

  studentExamNavigateToAssessment(exam: StudentExam) {
    let tab_status = 'open'
    if(new Date(exam.finish_by) < new Date())
      tab_status = 'past'
    this.router.navigate(['dashboard/assessments'], {queryParams: {search: exam.exam_title, type: 'exam', tab_status: tab_status}});
  }

  toggleDropdown(day: CalendarDay) {
    const whatTheDayToggleWas = day.toggleDropdown
    for(let week of this.calendarDays) {
      for(let calendarDay of week) {
        calendarDay.toggleDropdown = false
      }
    }
    day.toggleDropdown = !whatTheDayToggleWas
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
}
